import { Dialog, DialogMessage } from '@elementary/common-ui/components';
import { ReactComponent as InfoIcon } from '@elementary/common-ui/assets/alert-info.svg';

type EditConfirmationDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: string;
};

const EditConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  message,
}: EditConfirmationDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    onConfirmButtonClick={onConfirm}
    title="Confirm re-authentication"
    titleIcon={<InfoIcon />}
    message={message}
    secondaryMessage={
      <DialogMessage>This action is irreversible.</DialogMessage>
    }
    confirmText="Overwrite"
    variant="error"
    customWidth={540}
  />
);

export default EditConfirmationDialog;
